import { render } from "./Subject.vue?vue&type=template&id=2fa9e1c6&scoped=true"
import script from "./Subject.vue?vue&type=script&lang=js"
export * from "./Subject.vue?vue&type=script&lang=js"

import "./Subject.vue?vue&type=style&index=0&id=2fa9e1c6&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa9e1c6"]])

export default __exports__